<template>
  <div style="padding: 0 20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="toList()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <h2>基础设置</h2>
<!--        <el-tag type="info">基础设置</el-tag>-->
<!--        <el-form-item label="活动类型" required>
          <el-select v-model="form.type" @change="changeActivityType" placeholder="请选择" :disabled="type=='update'">
            <el-option
                v-for="item in typeOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key">
            </el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="标题" required>
          <el-input size="medium" v-model="form.title" style="width:400px"></el-input>
        </el-form-item>
<!--        <el-form-item label="活动期号" required>
          <el-input size="medium" v-model="form.stage" style="width:400px"></el-input>
        </el-form-item>-->
<!--        <el-form-item label="奖金金额" required>
          <el-input type="number" size="medium" v-model="form.bonus_amount" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="剩余奖金金额" required>
          <el-input type="number" size="medium" v-model="form.remaining_bonus" style="width:100px"></el-input> <span style="color:#909399">剩余难度</span>
        </el-form-item>
        <el-form-item label="初始奖金金额" required>
          <el-input type="number" size="medium" v-model="form.initial_bonus_start" style="width:100px"></el-input> ~
          <el-input type="number" size="medium" v-model="form.initial_bonus_end" style="width:100px"></el-input>
        </el-form-item>-->
        <el-form-item label="活动时间" required>
          <el-date-picker v-model="form.start_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开始时间" :disabled="type=='update'"></el-date-picker> ~
          <el-date-picker v-model="form.end_at" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择结束时间" :disabled="type=='update'"></el-date-picker>
        </el-form-item>
        <el-form-item label="新人数要求" required>
          <el-input type="number" size="medium" v-model="form.new_user_num" style="width:100px"></el-input><span>  人   </span><span style="color:#909399;margin-left: 2em">注:     请填写数字1~6，如填写5，则要求5人为新人才能激活全部脉轮</span>
        </el-form-item>
        <el-form-item label="奖码起始值" required>
          <el-input type="number" size="medium" v-model="form.lottery_code_start" style="width:100px"></el-input><span style="color:#909399;margin-left: 3.5em">注:     请填写一个五位数作为奖码发放起始值</span>
        </el-form-item>
        <el-divider></el-divider>

<!--        <el-tag type="info">福袋奖品设置</el-tag>-->
        <h2>福袋奖品设置</h2>
        <el-form-item label="体验营设置" required>
          <el-input type="number" size="medium" v-model="form.lucky_bag_ids[0]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.lucky_bag_ids[1]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.lucky_bag_ids[2]" style="width:100px"></el-input> <span style="color:#909399">课程ID</span>
        </el-form-item>
        <el-form-item label="优惠券设置" required>
          <el-input type="number" size="medium" v-model="form.lucky_bag_extra_ids[0]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.lucky_bag_extra_ids[1]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.lucky_bag_extra_ids[2]" style="width:100px"></el-input> <span style="color:#909399">优惠券ID</span>
        </el-form-item>
        <el-divider></el-divider>

<!--        <el-tag type="info">盲盒课程设置</el-tag>-->
        <h2>盲盒课程设置</h2>
        <el-form-item label="课程ID" required>
          <el-input type="number" size="medium" v-model="form.give_ids" style="width:100px"></el-input>
        </el-form-item>
<!--        <el-form-item label="课程名称" required>
          <el-input size="medium" v-model="form.lucky_bag_extra_ids[0]" style="width:100px"></el-input>
        </el-form-item>-->

<!--        <el-tag type="info">猜你喜欢设置</el-tag>-->
        <h2>猜你喜欢设置</h2>
        <el-form-item label="商品设置" required>
          <el-input type="number" size="medium" v-model="form.product_ids[0]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.product_ids[1]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.product_ids[2]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.product_ids[3]" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="课程设置" required>
          <el-input type="number" size="medium" v-model="form.course_ids[0]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.course_ids[1]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.course_ids[2]" style="width:100px"></el-input>，
          <el-input type="number" size="medium" v-model="form.course_ids[3]" style="width:100px"></el-input>
        </el-form-item>
        <el-divider></el-divider>
<!--        <el-tag type="info">本期大奖设置</el-tag>-->
        <h2>本期大奖设置</h2>
<!--        <template v-if="form.type == 1">
          <el-form-item label="奖品ID" required>
            <el-input type="number" size="medium" v-model="form.give_ids" style="width:100px"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="奖品ID" required>
            <el-select v-model="form.give_ids" placeholder="请选择">
              <el-option
                  v-for="item in vipList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
        </template>-->
        <el-form-item label="奖品ID" required>
          <el-input type="number" size="medium" v-model="form.lottery_give_ids" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="奖品标题" required>
          <el-input size="medium" v-model="form.lottery_give_title" style="width:400px"></el-input>
        </el-form-item>

        <el-form-item label="奖品图片" required>
          <el-upload
            class="avatar-uploader"
            :action="ossAction"
            :show-file-list="false"
            :http-request="uploadOSSRequest">
            <img v-if="form.lottery_give_img_url" :src="form.lottery_give_img_url" class="avatar" :preview-src-list="[form.lottery_give_img_url]">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="市场价" required>
          <el-input type="number" size="medium" v-model="form.lottery_give_price" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="数量" required>
          <el-input type="number" size="medium" v-model="form.lottery_give_num" style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="中奖公布时间" required>
<!--          <div class="block">
&lt;!&ndash;            <span class="demonstration">默认</span>&ndash;&gt;
            <el-date-picker
                v-model="form.lottery_time"
                type="datetime"
                placeholder="选择日期时间">
            </el-date-picker>
          </div>-->
          <el-date-picker v-model="form.lottery_time" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择开奖时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="脉轮测试链接">
          <el-input size="medium" v-model="form.test_url" style="width:400px"></el-input>
        </el-form-item>
<!--        <el-form-item label="奖品描述" required>
          <el-input size="medium" autosize v-model="form.give_intro" style="width:600px"></el-input>
        </el-form-item>
        <el-form-item label="奖品划线价" required>
          <el-input type="number" size="medium" v-model="form.give_scribing_price" style="width:100px"></el-input>
        </el-form-item>-->
        <el-divider></el-divider>
        <h2>分享设置</h2>
        <el-form-item label="分享图标" required>
          <el-upload
            class="avatar-uploader"
            :action="ossAction"
            :show-file-list="false"
            :http-request="uploadOSSRequest2">
            <img v-if="form.share_icon" :src="form.share_icon" class="avatar" :preview-src-list="[form.share_icon]">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="分享标题" required>
          <el-input size="medium" v-model="form.share_title" style="width:400px"></el-input>
        </el-form-item>
        <el-form-item label="分享描述" required>
          <el-input size="medium" autosize v-model="form.share_desc" style="width:600px"></el-input>
        </el-form-item>

        <el-form-item>
          <template v-if="type == 'create'">
            <el-button type="primary" @click="onSubmit" :loading="onSubmitLoading">立即创建</el-button>
          </template>
          <template v-else>
            <el-button type="primary" @click="onUpdate" :loading="onSubmitLoading">保存</el-button>
          </template>

          <el-button @click="toList()">取消</el-button>
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import {
  createChakras, getChakrasInfo, updateChakras
} from "@/api/activityChakras";
import { uploadOSSRequest, getAliyunOssToken } from "@/api/common";

export default {
  data: function() {
    return {
      formLoading:false,
      onSubmitLoading:false,
      chakrasId: '',
      ossAction: "",
      updateLoading: false,
      type:'create',
      data:{},
      typeOptions:[
        {key:1,value:"领课程"},
        {key:2,value:"领会员"},
      ],
      vipList:[
        {key:2,value:"七天会员"},
        {key:3,value:"半月会员"},
        {key:4,value:"月会员"},
        {key:6,value:"季会员"},
        {key:10,value:"年会员"},
      ],
      form:{
        lucky_bag_ids:[],
        lucky_bag_extra_ids:[],
        course_ids:[],
        product_ids:[],
        lottery_give_img_url:'',
        share_icon:'',
        type:1,
        give_ids:'',
      },
    };
  },
  created: function() {
    this.type = this.$route.query.type
    if(this.type == 'update'){
      this.chakrasId = this.$route.query.id;
      this.getChakrasInfo()
    }
  },
  methods: {
    /*changeActivityType(value){
      console.log(this.form.give_ids)
      if(value == 1){
        this.form.give_ids = ''
      }else{
        this.form.give_ids = 2
      }
    },*/
    getChakrasInfo(){
      this.formLoading = true;
      getChakrasInfo({
        id:this.chakrasId
      }).then((res) => {
        if(res.code == 1){
          this.formLoading = false;
          this.form = res.data
        }
      });
    },
    onUpdate(){
      this.onSubmitLoading = true;
      updateChakras(this.form).then((res) => {
        this.onSubmitLoading = false;
        if(res.code == 1){
          this.$message({
            showClose: true,
            duration: 6000,
            message: '修改成功',
            type: 'success'
          });
          this.toList();
        }
      });
    },
    onSubmit(){
      this.onSubmitLoading = true;
      createChakras(this.form).then((res) => {
        this.onSubmitLoading = false;
        if(res.code == 1){
          this.form = {
            lucky_bag_ids:[],
            lucky_bag_extra_ids:[],
            course_ids:[],
            product_ids:[],
            lottery_give_img_url:'',
            share_icon:'',
          }
          this.$message({
            showClose: true,
            duration: 6000,
            message: '创建成功',
            type: 'success'
          });
          this.toList();
        }
      });
    },
    uploadOSSRequest(file) {
        let that = this
        this.updateLoading = true;
        getAliyunOssToken({ dir: "activity/chakras/" }).then((res) => {
            uploadOSSRequest(file.file, res.data).then((fileUrl) => {
                that.form.lottery_give_img_url = fileUrl
            });
        });
    },
    uploadOSSRequest2(file) {
        let that = this
        this.updateLoading = true;
        getAliyunOssToken({ dir: "activity/assist/" }).then((res) => {
            uploadOSSRequest(file.file, res.data).then((fileUrl) => {
                that.form.share_icon = fileUrl
            });
        });
    },
    toList(){
      this.$router.push({
        path: "/activity/Chakras/data",
      });
    }
  }
};
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    min-height: 70px;
    line-height: 70px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    min-height: 70px;
    display: block;
  }
</style>

